(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glm-homepage"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('click', (event) => {
  const thumbnail = event.target.closest('[data-glm-photo]');
  if (!thumbnail || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  const gallery = thumbnail.closest('[data-glm-gallery]');
  const image = gallery?.querySelector('.glm-photo-main > img');
  const imageLink = gallery?.querySelector('[data-glm-main-link]');
  if (!image || !imageLink) return;
  event.preventDefault();
  image.srcset = thumbnail.dataset.photoSrcset;
  image.src = thumbnail.dataset.photoSrc;
  image.alt = thumbnail.dataset.photoAlt;
  image.style.objectPosition = thumbnail.dataset.photoPosition;
  imageLink.href = thumbnail.href;
  gallery.querySelectorAll('[data-glm-photo]').forEach((item) => item.setAttribute('aria-current', String(item === thumbnail)));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
